// @flow

import React, {Component} from 'react';
import {connector} from '../store';
import {Link} from 'react-router-dom';
import {getBasicVideoTrackingLabel, getVideoTrackingLabel, videoDataToPlayerData} from '../helpers';
import Clip from './Clip.jsx';

import ga from '../../../vendor/google-analytics';

export class ClipList extends Component<*, *> {
  trackingCategory: string;
  trackingLabel: ?string;

  componentDidMount() {
    this.trackingCategory = 'VideoPlayer | ClipList';
    this.trackingLabel = getBasicVideoTrackingLabel(this.props.show, this.props.player);

    if (this.trackingLabel) {
      ga('send', 'event', this.trackingCategory, 'Open | [P]', this.trackingLabel);
    }
  }

  componentWillUnmount() {
    if (this.trackingLabel) {
      ga('send', 'event', 'VideoPlayer | ClipList', 'Close | [P]', this.trackingLabel);
    }
  }

  render() {
    let playingId = this.props.player.currentlyPlaying.id,
        clipAction = this.props.clipAction;

    return (
      <div className="clipbar clipbar-list">
        <div className="clip-window">
          <div className="clip-container">
            {this.props.player.container.clips.map(function(clip, i) {
              let isPlaying = clip.id === playingId,
                  handler = () => {
                    let trackingLabel = getVideoTrackingLabel(this.props.show, this.props.player, clip.id);

                    if (trackingLabel) {
                      ga('send', 'event', this.trackingCategory, 'Click Clip | [A]', trackingLabel + ' | ' + (i + 1));
                    }

                    clipAction(videoDataToPlayerData(clip, true));
                  };

              let path = `/${this.props.show.slug}/video/${clip.slug}/`;
              let replace = path === window.location.pathname;

              return <Link className="no-delay" key={clip.id + '.' + i} to={path} replace={replace}>
                <Clip {...clip} isPlaying={isPlaying} handler={handler} />
              </Link>;
            }.bind(this))}
          </div>
        </div>
      </div>
    );
  }
}

export default connector(ClipList);